import jsPDF from 'jspdf';
import 'jspdf-autotable';
import imagePath from './image.png';

export const generatePDF = (host, selectedMonth) => {
  let monthKey = null;
  if (host.projects && host.projects.length > 0) {
    const keys = Object.keys(host.projects[0]);
    monthKey = keys.find(key => {
      const normalized = key.trim().toLowerCase();
      return normalized === 'month' || normalized === 'months';
    });
  }

  const filteredProjects = host.projects.filter(project => {
    const monthVal = monthKey ? project[monthKey] : (project.Months || project['Months '] || project.Month || project['Month ']);
    return monthVal === selectedMonth;
  });

  if (filteredProjects.length === 0) {
    console.log(`No projects for month ${selectedMonth} for ${host.Name} ${host.First}, PDF not generated.`);
    return null;
  }

  const containsJune2024OrHigher = filteredProjects.some(project => {
    // Log problematic dates
    if (!project['Date '] || typeof project['Date '] !== 'string') {
      console.log(`Invalid or missing date for ${host.Name} ${host.First} (PN: ${host.PN}):`, {
        project,
        date: project['Date ']
      });
      return false; // Skip invalid dates
    }

    const dateParts = project['Date '].split('.');
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10);
    const year = parseInt(dateParts[2], 10);
    
    // Log if date parts are invalid
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      console.error(`Invalid date format for ${host.Name} ${host.First} (PN: ${host.PN}):`, {
        date: project['Date '],
        parsed: { day, month, year }
      });
      return false;
    }

    return year > 2024 || (year === 2024 && month >= 6);
  });

  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    compress: true,
  });

  const imageWidth = 30;
  const imageHeight = 10;
  const pageWidth = doc.internal.pageSize.width;
  const imageX = pageWidth - imageWidth - 10;
  const imageY = 5;

  const title = "Arbeitszeitnachweis";
  const headers = [
    [
      'Name, First',
      'PN',
      'Office',
      'Project No',
      'Place',
      'Date',
      'Start',
      'End',
      'Duration',
      'Break',
      'Working Hours Net',
    ]
  ];

  const values = filteredProjects.map(project => [
    `${host.Name} ${host.First}`,
    project.PN,
    project.Office,
    project['Project No'] || '',
    project.Place,
    project['Date '] || '',
    project.Start,
    project.End,
    project.Duration,
    project['Break'] || '',
    project['Working Hours Net'] || ''
  ]);

  let totalPagesExp = "{total_pages_count_string}";

  const addPageNumbers = () => {
    let str = "Page " + doc.internal.getNumberOfPages();
    if (typeof doc.putTotalPages === 'function') {
      str = str + " of " + totalPagesExp;
    }
    doc.setFontSize(8);
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    doc.text(str, pageWidth / 2, pageHeight - 10, { align: 'center' });
  };

  doc.setFontSize(6);

  let textY = 20;

  doc.autoTable({
    head: headers,
    body: values,
    startY: textY + 5,
    didDrawPage: (data) => {
      doc.addImage(imagePath, 'PNG', imageX, imageY, imageWidth, imageHeight);
      doc.setFontSize(12);
      const titleWidth = doc.getTextWidth(title);
      const titleX = (pageWidth - titleWidth) / 2;
      doc.text(title, titleX, 10);
      addPageNumbers();
    },
    headStyles: {
      fillColor: [226,146,61],
    },
    styles: {
      fontSize: 7,
    },
    margin: { top: 25 }
  });

  const pageHeight = doc.internal.pageSize.height;
  const leftMargin = 14;
  const rightMargin = pageWidth - 14;

  const saldoY = doc.lastAutoTable.finalY + 10;
  const lineSpacing = 15;

  const nextLineY = saldoY + lineSpacing;
  doc.text("Unterschrift Arbeitnehmer", leftMargin, nextLineY + 35);
  doc.setTextColor(255);
  doc.text(`{sproof{${host.First},${host.Name},${host.Email},1}sproof}`, leftMargin, nextLineY + 25);
  doc.setTextColor(0);

  const footerStartY = pageHeight - 35;
  doc.setFontSize(8);
  doc.text("Time Change Service Logistik GmbH", leftMargin, footerStartY + 30);
  doc.text("Gerichtsstand Berlin", rightMargin - doc.getTextWidth("Gerichtsstand Berlin"), footerStartY + 20);
  doc.text("AG Charlottenburg HRB 167816B", rightMargin - doc.getTextWidth("AG Charlottenburg HRB 167816B"), footerStartY + 25);
  doc.text("Geschäftsführer: Marko Hafemann", rightMargin - doc.getTextWidth("Geschäftsführer: Marko Hafemann"), footerStartY + 30);

  if (typeof doc.putTotalPages === 'function') {
    doc.putTotalPages(totalPagesExp);
  }

  return doc.output('arraybuffer');
};
